import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import { personaHomePath } from '../lib/entryContext'

const HOME_NAMES: Record<string, string> = {
  '/platform': 'Platform overview',
  '/courier/deliveries': 'Deliveries',
  '/partner/orders': 'Partner orders',
  '/dashboard': 'Dashboard',
}

/** An address the app doesn't have. Says so, instead of jumping to the Dashboard without a word. */
export default function NotFoundPage() {
  const { pathname } = useLocation()
  const { activePersona } = useAuth()
  const home = personaHomePath(activePersona)

  return (
    <div className="max-w-md mx-auto space-y-4 pt-8 text-center">
      <h1 className="font-display font-bold text-2xl text-foreground">Page not found</h1>
      <p className="text-sm text-foreground-muted">
        There is no page at{' '}
        <code className="break-all rounded bg-surface-raised px-1.5 py-0.5 font-mono text-foreground">{pathname}</code>.
        The link may be old or mistyped.
      </p>
      <Link
        to={home}
        className="inline-flex items-center justify-center rounded-xl bg-accent px-5 py-2.5 text-sm font-semibold text-white hover:bg-accent-strong transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background"
      >
        Go to {HOME_NAMES[home]}
      </Link>
    </div>
  )
}
